import React, { useEffect } from "react";
import { useAnyModalOpen } from "../../hooks/useAnyModalOpen";
import { useCheckLocation } from "../../hooks/useCheckLocation";

const GlobalWidgets: React.FC = () => {
  const isOpenModal = useAnyModalOpen()
  const {isFormLocation} = useCheckLocation();

  const ANALYTICS_ID = "6f065883-68cd-47a7-b674-93100a339ed1";
  const SCRIPT_SRC =
    "https://analytics.me-team.org/js/bundle.min.js?v=20250414174";
  
  useEffect(() => {
    let interval: number;
  
    const findWidget = () => {
      const iframe = document.querySelector('iframe[name="helpcrunch-iframe"]') as HTMLElement | null;
      if (!iframe) return;
    
      if (isOpenModal || isFormLocation) {
        iframe.classList.add("hidden");
      } else {
        iframe.classList.remove("hidden");
      }
    };
  
    interval = window.setInterval(() => {
      const iframe = document.querySelector('iframe[name="helpcrunch-iframe"]');
      if (iframe) {
        findWidget();
        clearInterval(interval);
      }
    }, 300);
  
    return () => clearInterval(interval);
  }, [isOpenModal, isFormLocation]);


  useEffect(() => {
    if (window.self !== window.top) return;
    // Add HelpCrunch Chat widget
    window.helpcrunchSettings = {
      organization: "meteam",
      appId: "a49db63f-f5cd-4baa-b7dc-2691e28744c5",
    };

    const helpCrunchScript = document.createElement("script");
    helpCrunchScript.type = "text/javascript";
    helpCrunchScript.innerHTML = `
        (function(w,d){
          var hS = w.helpcrunchSettings;
          if (!hS || !hS.organization) {
            return;
          }
          var widgetSrc = 'https://embed.helpcrunch.com/sdk.js';
          w.HelpCrunch = function() {
            w.HelpCrunch.q.push(arguments);
          };
          w.HelpCrunch.q = [];
          
          function r() {
            if (d.querySelector('script[src="' + widgetSrc + '"]')) {
              return;
            }
            var s = d.createElement('script');
            s.async = 1;
            s.type = 'text/javascript';
            s.src = widgetSrc;
            (d.body || d.head).appendChild(s);
          }

          if (d.readyState === 'complete' || hS.loadImmediately) {
            r();
          } else if (w.attachEvent) {
            w.attachEvent('onload', r);
          } else {
            w.addEventListener('load', r, false);
          }
        })(window, document);
      `;

    document.body.appendChild(helpCrunchScript);

    return () => {
      document.body.removeChild(helpCrunchScript);
    };
  }, []);

  useEffect(() => {
    if (!document.getElementById("mta-script")) {
      const script = document.createElement("script");
      script.id = "mta-script";
      script.defer = true;
      script.src = SCRIPT_SRC;
      script.onload = () => {
        if (typeof window.initAnalytics === "function") {
          window.initAnalytics(ANALYTICS_ID);
        }
      };
      document.body.appendChild(script);
    }

    const handler = () => {
      if (window.AnalyticsClient?.instance?.captureVisitEvent) {
        window.AnalyticsClient.instance.captureVisitEvent();
      }
    };
    window.addEventListener("mta_initialized", handler);

    return () => {
      window.removeEventListener("mta_initialized", handler);
    };
  }, []);

  return null;
};

export default GlobalWidgets;
